import React from 'react'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import type { Team, Step } from '../../types/session.types'
import { TeamCard } from './TeamCard'
import styles from './TeamGrid.module.css'

export interface TeamGridProps {
  sessionId: string
  teams: Team[]
  stepsByTeam: Record<string, Step[]>
  className?: string
}

export function TeamGrid({ sessionId, teams, stepsByTeam, className }: TeamGridProps) {
  const navigate = useNavigate()

  return (
    <section className={clsx(styles.grid, className)} aria-label="Team status grid">
      {teams.map((team) => (
        <TeamCard
          key={team.id}
          team={team}
          steps={stepsByTeam[team.id] ?? []}
          onClick={() => navigate(`/war-room/${sessionId}/team/${team.id}`)}
        />
      ))}
    </section>
  )
}
